import { render, staticRenderFns } from "./PayrollTrackingModal.vue?vue&type=template&id=05884582"
import script from "./PayrollTrackingModal.vue?vue&type=script&lang=js"
export * from "./PayrollTrackingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports